/**
 * Depends on jquery validation js and marb-web.js
 * (to be used in mobile version refactor is needed)
 */

try {
	Marb.extend({
		Geo : (function() {

			var _addressAutocomplete;
            var _place;
            var _requiredPlaceComponents = {
                street_number: 'short_name',
                route: 'long_name'
            };

            var Util = {

        		googleTypeMatch : function (types, target){
            		for(var i=0; i < types.length; i++){
            			if( types[i] == target){
            				return true;
            			}
            		}
            		return false;
            	},
            	googleGetTypeValue : function(acs, target){
            		for(var i=0; i < acs.length; i++){
            			var ac = acs[i];
            			if( Marb.Geo.Util.googleTypeMatch(ac.types, target) ){
            				return ac.long_name;
            			}
                	}
            		return '';
            	},

            	googleNormalizeResultToMarbPlace : function(input){
                	var ac = input.address_components;
                	var util = Marb.Geo.Util;
                	var place = {};
                	place.streetName = util.googleGetTypeValue(ac, 'route');
                	place.streetNumber = util.googleGetTypeValue(ac, 'street_number');
                	place.zip = util.googleGetTypeValue(ac, 'postal_code').replace(/[ -]/g, '');
                    var vicinity = util.googleGetTypeValue(ac, 'sublocality_level_1');
                    var city = util.googleGetTypeValue(ac, 'locality') || '';
                    if( ! vicinity ){
                    	vicinity = util.googleGetTypeValue(ac, 'neighborhood');
                    }
                    if( ! vicinity ){
                    	vicinity = util.googleGetTypeValue(ac, 'locality');
                    }
                    if (!vicinity){
                        vicinity = util.googleGetTypeValue(ac, 'administrative_area_level_1') + ' ' + util.googleGetTypeValue(ac, 'administrative_area_level_2');
                    }
                    if( !vicinity ){
                    	vicinity = input.vicinity;
                    }
                    if( ! city ){
                    	city = util.googleGetTypeValue(ac, 'administrative_area_level_2');
                    }
                    place.neighbourhood = vicinity;
                    place.city = city;
                	place.state = util.googleGetTypeValue(ac, 'administrative_area_level_1');
                	if( typeof input.geometry.location.lat == "function" ){
                		place.latitude = input.geometry.location.lat().toFixed(8);
                		place.longitude = input.geometry.location.lng().toFixed(8);
                	}else{
                		place.latitude = input.geometry.location.lat.toFixed(8);
                		place.longitude = input.geometry.location.lng.toFixed(8);
                	}

                	return place;
                }

            };

            var googleToMarbGeocode = function(place, params) {
                var urlSearchLocation = "/geo/search";
                var sanitizedTerm = place.neighbourhood.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                var sanitizedState = place.state.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                var geoParams = {
                		term: sanitizedTerm,
                		state: sanitizedState,
            			lat: place.latitude,
            			lng: place.longitude
                };
                if( place.city && place.city.length > 0 ){
                	geoParams.city = place.city;
                }
                var trkParams = {
                	start: 'google-search-start',
                	success: 'google-search-success',
                	error: 'google-search-error',
                	value: sanitizedTerm
                };
                $.extend(trkParams, params.tracking);

                Marb.Commons.Track.event('geoloc', trkParams.start, trkParams.value);
                $.get(urlSearchLocation, geoParams, function(response){
                        if(response.success) {
                        	if( response.data.length > 0 ){
                        		Marb.Commons.Track.event('geoloc', trkParams.success, trkParams.value);
                        		params.onSuccess(response.data[0]);
                        	}else{
                        	    place.unavailableZone = true;
                        		Marb.Commons.Track.event('geoloc', trkParams.error, trkParams.value);
                        		const searchTerm = sanitizedTerm + ', ' + sanitizedState;
                                params.onError(searchTerm, place);
                        	}
                        }
                    }
                );
            };

			var setCityAutocomplete = function(params){
				var urlSearchLocation = "/geo/search?term={term}&filter=leaf&v=2";
	            var label = params.label;
	            var error = params.error;
	            var errorDefault = params.errorDefault;
	            var input = params.input;
	            var hidden = params.hidden;
                // Timeout is required so it changes the autocomplete after chrome sets the input's attribute autocomplete to 'off'
                setTimeout(function(){
                    input.attr('autocomplete', 'off');
                }, 1000);

	            input.autocomplete({
	                delay: 300,
	                minLength: 3,
	                autoFocus: true,
	                classes: {
	                    "ui-autocomplete": "ui-autocomplete-modal"
	                },
	                source: function (request, response) {
	                	var sanitizedTerm = request.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
	                    $.fn.getJson(urlSearchLocation.replace('{term}', sanitizedTerm), function (locations) {
	                        var resultsSearch = [];
	                        locations.data
	                            .forEach(function (view, index) {
	                                var result = {
	                                    label: view.label,
	                                    value: view.id
	                                };
	                                resultsSearch.push(result);
	                            });
	                        response(resultsSearch);
	                        input.removeClass("invalid");
	                        if( label ){
	                        	label.attr('data-error',errorDefault);
	                        }

	                        if (resultsSearch.length == 0) {
	                            hidden.val('');

	                            if( label ){
	                            	label.attr('data-error',error + " " + input.val());
	                            }
	                            input.addClass("invalid");
	                            input[0].setCustomValidity(error + '' +  input.val());
	                        }else{
	                        	input[0].setCustomValidity('');
	                        }
	                    });
	                },
	                select: function (event, ui) {
	                    event.preventDefault();
	                    $(this).val(ui.item.label);
	                    input.val(ui.item.label);
	                    hidden.val(ui.item.value);
	                },
	                focus: function (event, ui) {
	                    event.preventDefault();
	                }
	            })
	              .focusout(function () {
                    if ($(this).val().length < 3) {
                        hidden.val("");
                        if( label ){
                        	label.attr('data-error',errorDefault);
                        }
                    }
                    if (hidden.val().length == 0) {
                        $(this).val("");
                        if( label ){
                        	label.attr('data-error',errorDefault);
                        }
                    }
	              });
			};


			var setGoogleAddressAutocomplete = function(_params){
				var obj = this;
				var params = _params;
				var input = $(params.address_selector)[0];

				var restrictions = {country: params.country};
				_addressAutocomplete = new google.maps.places.Autocomplete(
					(input),
					{types: ['address'], componentRestrictions: restrictions});

				// When the user selects an address from the dropdown
				_addressAutocomplete.addListener('place_changed', function(){
					obj.fillInAddress();
				});

                this.fillInAddress = function() {

                    _place = _addressAutocomplete.getPlace();

                    if(obj.isValidAddress()) {
                    	var place = Marb.Geo.Util.googleNormalizeResultToMarbPlace(_place);
                        $(params.latitude_selector).val(place.latitude);
                        $(params.longitude_selector).val(place.longitude);
                        if( params.zip_selector && $(params.zip_selector).length > 0 ){
                        	$(params.zip_selector).val(place.zip);
                        }
                        googleToMarbGeocode(place, {
                        	onSuccess: function(data){
                        		$(params.location_selector).val(data.id);
                        		$(params.locationtxt_selector).val(data.label);
                        		if( params.callback ){
                                	params.callback(place);
                                }
                        	},
                        	onError: function(searchTerm, place){
                                if (params.onUnavailableZoneError && place.unavailableZone) {
                                    params.onUnavailableZoneError();
                                }
                        		if( params.onLocationSearchError){
                        			params.onLocationSearchError(searchTerm, place);
                        		}
                        	}
                        });
                    }else {
                        $(params.latitude_selector).val('0');
                        $(params.longitude_selector).val('0');
                        $(params.address_selector).val('');
                        $(params.zip_selector).val('');
                        if( params.onInvalidAddress ){
                    		params.onInvalidAddress(_place);
                    	}
                    }
                };

				this.isValidAddress = function(){
                    var requiredPlaceComponentsLength=0;
                    for (let i in _requiredPlaceComponents) if (_requiredPlaceComponents.hasOwnProperty(i)) requiredPlaceComponentsLength++;

                    var requiredElementsInPlace = 0;

                    if(_place && _place.address_components) {
                        for (let i = 0; i < _place.address_components.length; i++) {
                            var addressType = _place.address_components[i].types[0];
                            if (_requiredPlaceComponents[addressType]) {
                                requiredElementsInPlace++;
                            }
                        }
                        return requiredElementsInPlace == requiredPlaceComponentsLength;
                    }else{
                        return false;
                    }
                };
			};

			var resolveZipCodeToCity = function(params){
				const googleKey = params.googleKey;
				const query = params.zipCode + ', ' + params.countryName;
				$.get('https://geo.iguanafix.com/v1/geocode/json?address=' + query, function(response){
					if( ! response || ! response.results || response.status !== 'OK'){
						Marb.Commons.Track.event('geoloc','google-search-zip-start', query);
						if( params.onError ){
							params.onError;
						}else{
							cosole.error('error response from google zip code :');
							console.error(response);
						}
						return;
					}
					if( response.results.length > 1 ){
						Marb.Commons.Track.event('geoloc','google-search-zip-noresults-error', params.zipCode);
						if( params.onValidationError ){
							params.onValidationError();
						}
						return;
					}
					const util = Marb.Geo.Util;
					const result = response.results[0];
					if( ! util.googleTypeMatch(result.types, 'postal_code') ){
						Marb.Commons.Track.event('geoloc','google-search-zip-nozip-error', params.zipCode);
						if( params.onValidationError ){
							params.onValidationError();
						}
						return;
					}
					const place = util.googleNormalizeResultToMarbPlace(result);
					googleToMarbGeocode(place, {
						onSuccess: function(data){
							params.onSuccess(place, data);
						},
						onError: function(searchTerm, place){
							params.onUnsupportedLocation(place);
						},
						tracking: {
							start: 'google-search-zip-start',
							success: 'google-search-zip-success',
							error: 'google-search-zip-error',
							value: params.zipCode
						}
					});
				});
			};

			return {
				setCityAutocomplete : setCityAutocomplete,
				setGoogleAddressAutocomplete: setGoogleAddressAutocomplete,
				resolveZipCodeToCity: resolveZipCodeToCity,
				Util: Util
			};
		})()
	});
}
catch (e) {
	debug.error("Marb namespace not present", e);
}
